import {
  READ_CURRENT_BILL_SUMMARY_COMPLETE,
  READ_CURRENT_BILL_SUMMARY_ERROR,
  READ_CURRENT_BILL_SUMMARY_START,
  READ_CURRENT_BILL_SUMMARY_SUCCESS,
} from 'src/shared/currentBillSummary/actions';
import {createResourceReducer} from 'src/shared/utils/resource';

export const currentBillSummary = createResourceReducer({
  start: READ_CURRENT_BILL_SUMMARY_START,
  success: READ_CURRENT_BILL_SUMMARY_SUCCESS,
  error: READ_CURRENT_BILL_SUMMARY_ERROR,
  complete: READ_CURRENT_BILL_SUMMARY_COMPLETE,
});
